export default [
  'BOTStoreCityList',
  'BOTServiceCategoriesStatePage'
]

/*
Appears on:
location/state,
*/
